import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useConsent } from "../../hooks/useConsent";

export { getConsent } from "../../lib/consent";

const ConsentActions = ({ decide }) => (
  <div className="flex gap-3">
    <button data-testid="cookie-reject-btn" onClick={() => decide("rejected")}
      className="flex-1 rounded-full border border-white/20 px-6 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-white/10 md:flex-none">
      Rechazar
    </button>
    <button data-testid="cookie-accept-btn" onClick={() => decide("accepted")}
      className="flex-1 rounded-full bg-[#00E5FF] px-6 py-2.5 text-sm font-semibold text-[#0A0A0C] transition-transform hover:-translate-y-0.5 md:flex-none">
      Aceptar
    </button>
  </div>
);

export const CookieBanner = () => {
  const { open, decide } = useConsent();
  return (
    <AnimatePresence>
      {open && (
        <motion.div data-testid="cookie-banner" role="region" aria-label="Preferencias de cookies"
          initial={{ y: 120, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 left-4 right-4 z-[80] mx-auto max-w-3xl rounded-2xl border border-white/10 bg-[#101018]/95 p-6 shadow-2xl backdrop-blur-xl">
          <div className="flex flex-col gap-5 md:flex-row md:items-center md:justify-between">
            <div className="flex items-start gap-3">
              <Cookie className="mt-0.5 h-5 w-5 flex-shrink-0 text-[#00E5FF]" />
              <p data-testid="cookie-banner-description" className="text-sm leading-relaxed text-zinc-300">
                Usamos cookies técnicas necesarias para el funcionamiento de la web. Puedes
                aceptarlas o rechazarlas. Consulta más detalles en{" "}
                <Link to="/politica-de-cookies" data-testid="cookie-configure-link" className="text-[#00E5FF] underline underline-offset-4">Configurar</Link>.
              </p>
            </div>
            <ConsentActions decide={decide} />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};